import { Outlet } from "react-router-dom";
import AdminHeader from "./UI/admin-header/AdminHeader";
import { Suspense } from "react";

const AdminLayout = () => {
  return (
    <div className="mt-20">
      <AdminHeader />
      <Suspense>
        <Outlet />
      </Suspense>
    </div>
  );
};

export default AdminLayout;
